import { render, staticRenderFns } from "./ColorCheckbox.vue?vue&type=template&id=63784944&scoped=true&"
import script from "./ColorCheckbox.vue?vue&type=script&lang=js&"
export * from "./ColorCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./ColorCheckbox.vue?vue&type=style&index=0&id=63784944&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63784944",
  null
  
)

export default component.exports